import React, { useEffect, useState } from "react";
import Main from "../pages/Main";
import { useNavigate } from "react-router-dom";
import { getServices } from "../api/admin/FrServicesApi";
import { serviceRouteMap } from "../pages/services/mapRoutes";
import { REAL_BASE_URL } from "../api/axiosInstance";
import ServiceTile from "../components/ui/ServiceTile";
import { useNotify } from "../context/NotifyContext";
import { AppBreadcrumbs } from "../components/listing";

const RechargePayment = () => {
  const navigate = useNavigate();
  const { notify } = useNotify();
  const [services, setServices] = useState([]);
  const fetchServices = async () => {
    try {
      const res = await getServices();
      if (!res?.success) {
        notify(res?.message || "Failed to fetch services", "error");
        return;
      }
      setServices(res.data || []);
    } catch (error) {
      notify("Something went wrong while fetching services", "error");
    }
  };
  useEffect(() => {
    fetchServices();
  }, []);

  const serviceIcon = (s) => {
    if (!s?.icon) return null;
    const path = String(s.icon).trim();
    if (!path || path === "null" || path === "undefined") return null;
    if (/^https?:\/\//i.test(path)) return path;
    return `${REAL_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
  };

  return (
    <Main showRightPanel={false}>
      <div className="mt-2">
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "Recharge & Bills" },
            { label: "Payment History" },
            { label: "Select Category" },
          ]}
        />

        <div className="ds-card mb-4">
          <h2 className="text-[16px] font-semibold mb-3 text-[var(--text-dark)]">
            Bill Payments Solutions with BBPS Technology
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 text-[13px] text-[var(--text-muted)]">
            {[
              "Recurring Income with Recurring Utility Bills.",
              "Turn Your Shop Into One-Stop Payment Centre.",
              "Best Success Rate, Safe and Reliable Transactions.",
              "Instant Confirmation on the Bill Payments.",
            ].map((item, index) => (
              <div key={index} className="flex items-start gap-2">
                <input
                  type="checkbox"
                  checked
                  readOnly
                  className="mt-0.5 w-4 h-4 accent-[var(--primary-color)] cursor-default"
                />
                <p>{item}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="ds-card">
          <h2 className="text-[16px] font-semibold mb-4 text-[var(--text-dark)]">
            Select Bill Category
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
            {services && services.length > 0 ? (
              services.map((s) => (
                <ServiceTile
                  key={s._id}
                  name={s.name}
                  iconSrc={serviceIcon(s)}
                  inactive={!s.isActive}
                  onClick={() => {
                    if (s.isActive) navigate(`/service/${s.slug}`);
                  }}
                />
              ))
            ) : (
              <div className="col-span-full text-center py-8 text-[var(--text-muted)] text-sm">
                No services available
              </div>
            )}
          </div>
        </div>
      </div>
    </Main>
  );
};
export default RechargePayment;
